'use client';

import * as React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

export interface CollectionListProps {
  address: string;
  tokensHold: number;
  price: number;
  isFree: boolean;
  isDiscount: boolean;
  discountPercentage: number;
  count?: number;
}

export interface CollectionListContextType {
  collectionList: CollectionListProps[];
  setCollectionList(f: CollectionListProps[] | ((prev: CollectionListProps) => CollectionListProps)): void;
}

const CollectionListContext = createContext<CollectionListContextType>({} as CollectionListContextType);

export const useCollection = () => {
  return useContext(CollectionListContext);
};

export const CollectionListProvider = ({ children }: { children: React.ReactNode }) => {
  const [collectionList, setCollectionList] = useState<CollectionListProps[]>([]);

  const values = useMemo<CollectionListContextType>(() => {
    return {
      collectionList,
      setCollectionList
    } as CollectionListContextType;
  }, [collectionList, setCollectionList]);

  return <CollectionListContext.Provider value={values}>{children}</CollectionListContext.Provider>;
};
